import type { RgbaImage } from './rotate';

/** Exact pixel overlays on the unchanged hull grid. Contact/clearance still uses the hull. */
export function composeBoatAppearance(hull: RgbaImage, fittings: readonly RgbaImage[]): RgbaImage {
  if (fittings.length === 0) return hull;
  const rgba = new Uint8ClampedArray(hull.rgba);
  for (const fitting of fittings) {
    if (fitting.w !== hull.w || fitting.h !== hull.h || fitting.rgba.length !== rgba.length) {
      throw new Error('Boat fitting must share the hull authoring grid');
    }
    for (let i = 0; i < rgba.length; i += 4) {
      if (fitting.rgba[i + 3]! < 128) continue;
      rgba[i] = fitting.rgba[i]!;
      rgba[i + 1] = fitting.rgba[i + 1]!;
      rgba[i + 2] = fitting.rgba[i + 2]!;
      rgba[i + 3] = 255;
    }
  }
  return { w: hull.w, h: hull.h, rgba };
}
